import { createSlice } from "@reduxjs/toolkit";

interface ClinicDisable {
  ClinicDisableState: boolean;
}

const initialState: ClinicDisable = {
  ClinicDisableState: false,
};

const ClinicDisableSlice = createSlice({
  name: "ClinicDisable",
  initialState,
  reducers: {
    enableClinic: (state: ClinicDisable) => {
      state.ClinicDisableState = false;
    },
    disableClinic: (state: ClinicDisable) => {
      state.ClinicDisableState = true;
    },
  },
});

export const { disableClinic, enableClinic } = ClinicDisableSlice.actions;

export default ClinicDisableSlice.reducer;
